import React from 'react'
import Hero from '../components/Hero'
import GlobalHiring from '../components/GlobalHiring'
import {  headings, StaffingIndependentdata } from '../data/GlobalHiringData'
import CardSection from '../components/CardSection'
import {  featureStaffingIndependent } from '../data/CardSectionData'
import {  featuresStaffingIndependentdata } from '../data/CardData'
import TextwithImage from '../components/TextwithImage'
import { textSections } from '../data/TextwithimageData'
import HireSection from '../components/HireSection'
import { hiringsectionincompany } from '../data/HiresectionData'
import { useNavigate } from 'react-router-dom'
import StaffingIndependentTech from '../components/StaffingIndepententTech'
import DynamicClient from '../data/DynamicClient'

const StaffingIndependent = () => {
  const navigate = useNavigate();
    const buttons = [
        { text: "Speak to an expert" , buttonClass: "companyFirstbutton"  }
      ];
  return (
    <>
    <Hero
      title="Independent Contractor Management"
      description="Efficient contractor management ensures compliance, fosters strong relationships, and drives business growth. By streamlining onboarding, payments, and ongoing support, businesses can harness the full potential of their independent workforce"
      buttonText="Connect with Expert"
      customClass="CompanyHiringBanner"
      imageSrc="/images/hero.jpg"
      squareColor="CompanyHiringsquare-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
   <TextwithImage data={textSections.pageStaffingIndependent} />
    <GlobalHiring services={StaffingIndependentdata} customClass='contingentservice' heading={headings.page2}/>
    <CardSection data={featureStaffingIndependent} featuress={featuresStaffingIndependentdata} customClass ='EorCard' />
    <StaffingIndependentTech/>
    <TextwithImage data={textSections.PageStaffingIndependentList}/>
    <DynamicClient customClass="homepageclient"/>
    <HireSection
        imageSrc={hiringsectionincompany.imageSrc}
        title={hiringsectionincompany.title}
        description={hiringsectionincompany.description}
        buttonText={buttons}
        className={hiringsectionincompany.className}
      />
    </>
  )
}

export default StaffingIndependent